module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 20.5a64a2e6.png";